import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core";
import { Colors } from "../../../../helpers/theme";

const useClaimFailedStyles = makeStyles((theme) => ({
  modalpages: {
    "& h2": {
      [theme.breakpoints.down("md")]: {
        marginBottom: "12px",
        fontSize: theme.typography.h3.fontSize,
      },
    },
    "& .t-color": {
      color: Colors.darkSlate,
      "& br": {
        [theme.breakpoints.down("xs")]: {
          display: "none",
        },
      },
    },

    "& .border-box": {
      border: `1px solid ${alpha(Colors.black, 0.1)}`,
      borderRadius: "8px",
    },

    "& .button-buy": {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingRight: theme.spacing(6),
      paddingLeft: theme.spacing(6),

      [theme.breakpoints.down("sm")]: {
        minWidth: "100%",
      },
    },
    "& .relative-box": {
      position: "relative",
    },
    "& .cross-icon": {
      position: "absolute",
      right: "0",
      top: "-32px",
      cursor: "pointer",
      "&:hover": {
        fill: Colors.black,
      },
      [theme.breakpoints.down("sm")]: {
        top: "0px",
      },
    },
    "& .boxItem": {
      width: "100px",
    },
    "& .m-text": {
      marginRight: theme.spacing(1),
    },
    "& .dot": {
      height: "5px",
      width: "5px",
      backgroundColor: Colors.darkSlate,
      borderRadius: "50%",
      display: "inline-block",
      verticalAlign: "middle",
      marginBottom: "3px",
    },
    "& .t-decoration": {
      textDecoration: "underline",
    },
    "& .longbutton": {
      "& .MuiButton-root.MuiButton-medium": {
        minWidth: "198px",
        [theme.breakpoints.down("sm")]: {
          minWidth: "100%",
        },
      },
    },
    "& .uploadfile": {
      background: Colors.white,
      border: "1px dashed rgba(17, 48, 45, 0.1)",
      borderRadius: theme.spacing(1),
      padding: theme.spacing(4),
      textAlign: "center",
      "& img": {
        marginBottom: "18px",
      },
    },
    "& .uploading": {
      border: "1px solid rgba(17, 48, 45, 0.1)",
      borderRadius: theme.spacing(1),
      padding: theme.spacing(2),
    },
    "& .modal-btn-group": {
      [theme.breakpoints.down("sm")]: {
        display: "flex",
        justifyContent: "space-between",
      },

      "& .button-buy": {
        [theme.breakpoints.down("sm")]: {
          minWidth: "48%",
          minHeight: "48px",
        },
      },
    },
    "&.fullHeight": {
      "& .MuiDialog-paperWidthSm": {
        [theme.breakpoints.down("xs")]: {
          height: "calc(100% - 65px)",
          borderRadius: "0",
        },
      },
    },
    "&.modal-large": {
      "& .MuiDialog-paperWidthSm": {
        width: "540px",
      },
    },
    "& .connect-wallet-res": {
      [theme.breakpoints.down("sm")]: {
        marginLeft: 0,
      },
      [theme.breakpoints.down("xs")]: {
        marginLeft: theme.spacing(2),
      },
    },
    "& .connect-wallet-res-checkbox": {
      [theme.breakpoints.down("sm")]: {
        marginTop: theme.spacing(0),
      },
      [theme.breakpoints.down("xs")]: {
        marginTop: theme.spacing(2),
      },
    },
    "& .connect-nework-res": {
      [theme.breakpoints.down("sm")]: {
        marginLeft: theme.spacing(0),
        marginTop: theme.spacing(0),
      },
      [theme.breakpoints.down("xs")]: {
        minWidth: "40px",
      },
    },
    "& .greyicons": {
      filter: "grayscale(100%)",
      "& img": {
        cursor: "no-drop",
      },
    },
    "& .networks": {
      position: "relative",
      "& svg": {
        display: "none",
        position: "absolute",
        right: "-6px",
        bottom: "-3px",
        fontSize: "18px",
      },
    },
    "& .show": {
      "& svg": {
        display: "block !important",
      },
    },
    "& .character": {
      boxSizing: "border-box",
      height: "48px",
      minWidth: "48px",
      padding: "12px 0px",
      fontFamily: theme.typography.fontFamily,
      lineHeight: theme.typography.body1.lineHeight,
      fontSize: theme.typography.body1.fontSize,
      color: Colors.black,
      border: " 1px solid #E3E6EC",
      borderRadius: "4px",
      marginLeft: "12px",
      "&:first-child": {
        marginLeft: "0",
      },
      [theme.breakpoints.down("xs")]: {
        minWidth: "40px",
      },
    },
    "& .fs-text": {
      fontSize: "0.813rem",
    },
    "& .responsive-btn": {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingRight: theme.spacing(6),
      paddingLeft: theme.spacing(6),
      [theme.breakpoints.down("xs")]: {
        minWidth: "100%",
      },
    },
    "& .suodo-text": {
      position: "relative",

      "&:before": {
        content: `" "`,
        position: "absolute",
        width: "45%",
        height: "1px",
        background: "rgba(17, 48, 45, 0.1)",
        left: "0px",
        top: "6px",
      },
      "&:after": {
        content: `" "`,
        position: "absolute",
        width: "45%",
        height: "1px",
        background: "rgba(17, 48, 45, 0.1)",
        right: "0px",
        top: "6px",
      },
    },
    "& .button-res": {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingRight: theme.spacing(5.5),
      paddingLeft: theme.spacing(5.5),
      [theme.breakpoints.only("sm")]: {
        minWidth: "50%",
      },
      [theme.breakpoints.down("xs")]: {
        minWidth: "100%",
      },
    },
    "& .contribute-btn": {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingRight: theme.spacing(6),
      paddingLeft: theme.spacing(6),

      [theme.breakpoints.down("xs")]: {
        minWidth: "98%",
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingRight: theme.spacing(0),
        paddingLeft: theme.spacing(0),
      },
    },
    "& .action": {
      backgroundColor: `${alpha(Colors.green, 0.2)}`,
      color: Colors.black,
    },
    "& .warning-text": {
      [theme.breakpoints.down("sm")]: {
        "& br": {
          display: "none",
        },
      },
    },
  },
  progressTitle: {
    fontFamily: "Oxygen, sans-serif",
    fontWeight: 700,
    fontSize: "32px",
    lineHeight: "48px",
    textAlign: "center",
    color: Colors.greenDark,
  },
  progressMessage: {
    fontFamily: "Oxygen, sans-serif",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "25px",
    textAlign: "center",
    color: Colors.greySlate,
  },
}));

export default useClaimFailedStyles;
